<template>
  <v-row class="right-panel">
    <v-col col="12" v-if="$vuetify.breakpoint.mdAndDown">
      <v-card class="mx-auto dialog-cls" outlined>
        <v-card-title class="header-title">FILTERS</v-card-title>
        <v-divider></v-divider>
        <div class="filters-box">
          <v-card-text class="dialog-text px-15 py-0 mt-5 scroll-box">
            <span class="dialog-sub-title mt-5">Availability</span>
            <v-radio-group v-model="stockStatus" row dense>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio label="In stock" value="In stock"></v-radio>
              <v-radio label="Out of Stock" value="Out of Stock"></v-radio>
              <v-radio
                label="Available in 1 week"
                value="Available in 1 week"
              ></v-radio>
              <v-radio
                label="Available in 2 weeks"
                value="Available in 2 weeks"
              ></v-radio>
              <v-radio
                label="Available in 3 weeks"
                value="Available in 3 weeks"
              ></v-radio>
              <v-radio
                label="Available in 4 weeks"
                value="Available in 4 weeks"
              ></v-radio>
              <v-radio label="Coming Soon" value="Coming Soon"></v-radio>
              <v-radio label="Low Stock" value="Low Stock"></v-radio>
            </v-radio-group>

            <span class="dialog-sub-title mt-5">Manufacturer</span>
            <v-radio-group v-model="manufacturer" row dense>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio
                v-for="manufact in manufacturList"
                :key="manufact._id"
                :label="manufact.name"
                :value="manufact._id"
              ></v-radio>
            </v-radio-group>

            <span class="dialog-sub-title my-5">Product Type</span>
            <v-radio-group v-model="productType" row dense>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio label="Flowers" value="Flowers"></v-radio>
              <v-radio label="Oil" value="Oil"></v-radio>
              <v-radio label="Oil Spray" value="Oil Spray"></v-radio>
              <v-radio
                label="Tablets/Capsules"
                value="Tablets/Capsules"
              ></v-radio>
            </v-radio-group>

            <span class="dialog-sub-title my-5">Profile Type</span>
            <v-radio-group v-model="profileType" row dense>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio label="Indica" value="Indica"></v-radio>
              <v-radio
                label="Indica dominant hybrid"
                value="Indica dominant hybrid"
              ></v-radio>
              <v-radio label="Sativa" value="Sativa"></v-radio>
              <v-radio
                label="Sativa dominant hybrid"
                value="Sativa dominant hybrid"
              ></v-radio>
              <v-radio label="Hybrid" value="Hybrid"></v-radio>
              <v-radio label="Isolates" value="Isolates"></v-radio>
              <v-radio label="N/A" value="N/A"></v-radio>
            </v-radio-group>

            <span class="dialog-sub-title my-5">Cannabinoids</span>
            <v-radio-group v-model="cannabinoid" row dense>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio label="CBD Rich" value="CBD Rich"></v-radio>
              <v-radio label="THC Rich" value="THC Rich"></v-radio>
              <v-radio label="Balanced Ratio" value="Balanced Ratio"></v-radio>
            </v-radio-group>

            <span class="dialog-sub-title my-5">Delivery Method</span>
            <v-radio-group v-model="deliveryMethod" row dense>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio
                label="Inhaled via vaporiser"
                value="Inhaled via vaporiser"
              ></v-radio>
              <v-radio label="Oral" value="Oral"></v-radio>
              <v-radio
                label="Oral Sublingual"
                value="Oral Sublingual"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" @click="resetFilter">Clear</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col xs="12" sm="12" md="12" lg="10" xl="10">
      <v-card outlined class="dialog-cls">
        <v-card-title
          :class="
            $vuetify.breakpoint.lgAndUp
              ? 'header-title product-header-padding'
              : 'header-title'
          "
        >
          PRODUCTS
          <v-spacer></v-spacer>
          <v-btn-toggle
            v-model="selectedList"
            tile
            group
            v-if="$vuetify.breakpoint.mdAndUp"
          >
            <v-btn>
              <v-tooltip
                bottom
                :color="$vuetify.theme.themes.light.tooltipColor"
              >
                <template v-slot:activator="{ on: tooltip, attrs }">
                  <v-icon color="white" v-bind="attrs" v-on="{ ...tooltip }"
                    >mdi-view-list</v-icon
                  >
                </template>
                <span>List View</span>
              </v-tooltip>
            </v-btn>
            <v-btn>
              <v-tooltip
                bottom
                :color="$vuetify.theme.themes.light.tooltipColor"
              >
                <template v-slot:activator="{ on: tooltip, attrs }">
                  <v-icon color="white" v-bind="attrs" v-on="{ ...tooltip }"
                    >mdi-view-grid</v-icon
                  >
                </template>
                <span>Grid View</span>
              </v-tooltip>
            </v-btn>
          </v-btn-toggle>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="scroll-box">
          <div class="dialog-cls product-section">
            <v-row>
              <v-col
                xs="12"
                sm="12"
                :md="selectedOption == 0 ? 12 : 6"
                :lg="selectedOption == 0 ? 12 : 6"
                :xl="selectedOption == 0 ? 12 : 6"
                v-for="product in producList"
                :key="product._id"
              >
                <list-grid
                  :selectedList="Number(selectedOption || 0)"
                  :product="product"
                ></list-grid>
              </v-col>
              <v-col cols="12">
                <infinite-loading @infinite="infiniteHandler">
                  <div slot="spinner">
                    <v-row>
                      <v-col
                        xs="12"
                        sm="12"
                        :md="selectedOption == 0 ? 12 : 6"
                        :lg="selectedOption == 0 ? 12 : 6"
                        :xl="selectedOption == 0 ? 12 : 6"
                        v-for="n in 9"
                        :key="n"
                      >
                        <v-skeleton-loader
                          ref="skeleton"
                          :boilerplate="boilerplate"
                          type="card"
                          class="mx-auto"
                        ></v-skeleton-loader>
                      </v-col>
                    </v-row>
                  </div>
                  <div slot="no-more"></div>
                  <div slot="no-results" class="no-results">
                    <v-card elevation="0">
                      <v-card-title class="dialog-title-sm">
                        <v-spacer></v-spacer>
                        <strong>Sorry 😞</strong>, we couldn't find any results.
                        <v-spacer></v-spacer>
                      </v-card-title>
                    </v-card>
                  </div>
                </infinite-loading>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      xs="12"
      sm="12"
      md="12"
      lg="2"
      xl="2"
      v-if="$vuetify.breakpoint.lgAndUp"
    >
      <v-card class="mx-auto dialog-cls" outlined>
        <v-card-title class="header-title">FILTERS</v-card-title>
        <v-divider></v-divider>
        <div class="filters-box">
          <v-card-text class="dialog-text py-0 scroll-box">
            <v-radio-group v-model="stockStatus" column dense>
              <span class="dialog-sub-title mb-2">Availability</span>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio label="In stock" value="In stock"></v-radio>
              <v-radio label="Out of Stock" value="Out of Stock"></v-radio>
              <v-radio
                label="Available in 1 week"
                value="Available in 1 week"
              ></v-radio>
              <v-radio
                label="Available in 2 weeks"
                value="Available in 2 weeks"
              ></v-radio>
              <v-radio
                label="Available in 3 weeks"
                value="Available in 3 weeks"
              ></v-radio>
              <v-radio
                label="Available in 4 weeks"
                value="Available in 4 weeks"
              ></v-radio>
              <v-radio label="Coming Soon" value="Coming Soon"></v-radio>
              <v-radio label="Low Stock" value="Low Stock"></v-radio>
            </v-radio-group>

            <v-radio-group v-model="manufacturer" column dense>
              <span class="dialog-sub-title mb-2">Manufacturer</span>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio
                v-for="manufact in manufacturList"
                :key="manufact._id"
                :label="manufact.name"
                :value="manufact._id"
              ></v-radio>
            </v-radio-group>

            <v-radio-group v-model="productType" column dense>
              <span class="dialog-sub-title mb-2">Product Type</span>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio label="Flowers" value="Flowers"></v-radio>
              <v-radio label="Oil" value="Oil"></v-radio>
              <v-radio label="Oil Spray" value="Oil Spray"></v-radio>
              <v-radio
                label="Tablets/Capsules"
                value="Tablets/Capsules"
              ></v-radio>
            </v-radio-group>

            <v-radio-group v-model="profileType" column dense>
              <span class="dialog-sub-title mb-2">Profile Type</span>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio label="Indica" value="Indica"></v-radio>
              <v-radio
                label="Indica dominant hybrid"
                value="Indica dominant hybrid"
              ></v-radio>
              <v-radio label="Sativa" value="Sativa"></v-radio>
              <v-radio
                label="Sativa dominant hybrid"
                value="Sativa dominant hybrid"
              ></v-radio>
              <v-radio label="Hybrid" value="Hybrid"></v-radio>
              <v-radio label="Isolates" value="Isolates"></v-radio>
              <v-radio label="N/A" value="N/A"></v-radio>
            </v-radio-group>

            <v-radio-group v-model="cannabinoid" column dense>
              <span class="dialog-sub-title mb-2">Cannabinoids</span>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio label="CBD Rich" value="CBD Rich"></v-radio>
              <v-radio label="THC Rich" value="THC Rich"></v-radio>
              <v-radio label="Balanced Ratio" value="Balanced Ratio"></v-radio>
            </v-radio-group>

            <v-radio-group v-model="deliveryMethod" column dense>
              <span class="dialog-sub-title mb-2">Delivery Method</span>
              <v-radio label="Any" value="any"></v-radio>
              <v-radio
                label="Inhaled via vaporiser"
                value="Inhaled via vaporiser"
              ></v-radio>
              <v-radio label="Oral" value="Oral"></v-radio>
              <v-radio
                label="Oral Sublingual"
                value="Oral Sublingual"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" @click="resetFilter">Clear</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { ProductService } from "@/services";

export default {
  name: "Product",
  components: {
    InfiniteLoading,
    ListGrid: () => import("./ListGrid")
  },
  data() {
    return {
      selectedList: this.$route.query.selectedList || 0,
      selectedOption: 0,
      stockStatus: null,
      manufacturList: [],
      manufacturer: null,
      deliveryMethod: null,
      boilerplate: false,
      producList: [],
      page: 1,
      perPage: 10,
      price: null,
      productType: null,
      profileType: null,
      cannabinoid: null,
      query: {},
      items: [
        { title: "Home", icon: "mdi-home-city" },
        { title: "My Account", icon: "mdi-account" },
        { title: "Users", icon: "mdi-account-group-outline" }
      ]
    };
  },
  watch: {
    productType() {
      this.search();
    },
    profileType() {
      this.search();
    },
    cannabinoid() {
      this.search();
    },
    stockStatus() {
      this.search();
    },
    manufacturer() {
      this.search();
    },
    deliveryMethod() {
      this.search();
    },
    selectedList() {
      this.selectedOption = this.selectedList;
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const response = await ProductService.getManufacturNameList();
      if (response.data) {
        this.manufacturList = response.data;
      }
    },
    async infiniteHandler($state) {
      if (this.$route.query) {
        if (this.$route.query.productType) {
          this.productType = this.$route.query.productType;
        }

        if (this.$route.query.profileType) {
          this.profileType = this.$route.query.profileType;
        }

        if (this.$route.query.cannabinoid) {
          this.cannabinoid = this.$route.query.cannabinoid;
        }

        if (this.$route.query.stockStatus) {
          this.stockStatus = this.$route.query.stockStatus;
        }

        if (this.$route.query.manufacturer) {
          this.manufacturer = this.$route.query.manufacturer;
        }

        if (this.$route.query.deliveryMethod) {
          this.deliveryMethod = this.$route.query.deliveryMethod;
        }

        if (this.$route.query.selectedList) {
          this.selectedOption = Number(this.$route.query.selectedList);
          this.selectedList = this.selectedOption;
        }
      }

      const params = {
        limit: parseInt(this.perPage),
        skip:
          parseInt(this.page) * parseInt(this.perPage) - parseInt(this.perPage),
        productType: this.productType !== "any" ? this.productType : null,
        profileType: this.profileType !== "any" ? this.profileType : null,
        cannabinoid: this.cannabinoid !== "any" ? this.cannabinoid : null,
        stockStatus: this.stockStatus !== "any" ? this.stockStatus : null,
        manufacturer: this.manufacturer !== "any" ? this.manufacturer : null,
        deliveryMethod:
          this.deliveryMethod !== "any" ? this.deliveryMethod : null,
        status: 1,
        isPatient: true
      };
      const producList = await ProductService.getList(params);
      if (producList.data.data.length > 0) {
        this.page += 1;
        this.producList.push(...producList.data.data);
        if (producList.data.option[0].count > this.producList.length) {
          $state.loaded();
        } else {
          $state.loaded();
          $state.complete();
        }
      } else {
        $state.complete();
      }
    },
    async search() {
      this.query.productType = this.productType;
      this.query.profileType = this.profileType;
      this.query.cannabinoid = this.cannabinoid;
      this.query.stockStatus = this.stockStatus;
      this.query.manufacturer = this.manufacturer;
      this.query.deliveryMethod = this.deliveryMethod;
      this.query.selectedList = this.selectedOption;
      this.producList = [];
      this.page = 1;
      this.$router
        .replace({ query: this.query })
        .catch(err => console.log(err));
    },
    resetFilter() {
      this.productType = null;
      this.profileType = null;
      this.cannabinoid = null;
      this.stockStatus = null;
      this.manufacturer = null;
      this.deliveryMethod = null;
      delete this.query.productType;
      delete this.query.profileType;
      delete this.query.cannabinoid;
      delete this.query.stockStatus;
      delete this.query.manufacturer;
      delete this.query.deliveryMethod;
      this.$router
        .replace({ query: this.query })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style lang="scss" scoped>
.product-header-padding {
  padding: 2px 16px;
}
.dialog-cls {
  .scroll-box {
    max-height: 620px;
    height: 620px;
    overflow-y: auto;
  }
}
.filters-box {
  .scroll-box {
    max-height: 567px;
    height: 567px;
    overflow-y: auto;
  }
}
</style>
